import { render, staticRenderFns } from "./SktFree15000.vue?vue&type=template&id=77b524fc&scoped=true"
import script from "./SktFree15000.vue?vue&type=script&lang=js"
export * from "./SktFree15000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b524fc",
  null
  
)

export default component.exports